import PrepaidPaymentInfo from '@components/prepaid/PrepaidPaymentInfo';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';

import { amountAtom } from '../../../_shared/atoms/prepaidCardAtoms';

function PaymentInfo() {
    const { t } = useTranslation('prepaidCard');
    const amount = useAtomValue(amountAtom);

    return (
        <PrepaidPaymentInfo
            amountWon={amount}
            amountLabel={t('image.chargeAmount')}
            totalLabel={t('image.finalPaymentAmount')}
        />
    );
}

export default PaymentInfo;
